import script from "./HowToUseThisPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToUseThisPage.vue?vue&type=script&setup=true&lang=js"

import "./HowToUseThisPage.vue?vue&type=style&index=0&id=7d59d628&lang=css"

const __exports__ = script;

export default __exports__